import React from 'react';
import { Button, Grid, Typography, withStyles } from '@material-ui/core';

import ConfirmButton from '../components/Button/ConfirmButton';
import UserInfoTable from './UserInfoTable';
import AbstractTable from './AbstractTable';
// import RegistrationTable from './RegistrationTable';
// import SpeakerTable from './SpeakerTable';

const styles = (theme) => ({
  gridContainer: {
    paddingBottom: theme.spacing(5),
  },

  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '1.3em',
  },
});

class MyPageHome extends React.Component {
  render() {
    const { classes, theme } = this.props;

    return (
      <>
        <Grid item>
          {this.props.userInfo && this.props.userInfo.firstName && (
            <h2>
              Welcome, {this.props.userInfo.firstName} {this.props.userInfo.lastName}
            </h2>
          )}
        </Grid>
        <Grid item className={classes.gridContainer}>
          <Typography className={classes.title} gutterBottom>
            Personal Information
          </Typography>
          <UserInfoTable isSummary={true} mode={'read'} userInfo={this.props.userInfo} lang={this.props.lang} />
          <div style={{ textAlign: 'center', paddingTop: theme.spacing(3) }}>
            <ConfirmButton color="primary" onClick={() => this.props.handleState('sidx', 1)}>
              Review & Modify
            </ConfirmButton>
          </div>
        </Grid>
        {/* <Grid item className={classes.gridContainer}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <Typography className={classes.title} gutterBottom>
              Registration Submission
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disableElevation
              onClick={() => this.props.movePage('/registration/submission')}
            >
              Go to registration
            </Button>
          </div>
          <RegistrationTable />
        </Grid> */}
        <Grid item className={classes.gridContainer}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <Typography className={classes.title} gutterBottom>
              Free Paper Submission
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disableElevation
              onClick={() => this.props.movePage('/paper/submission')}
            >
              Make a new submission
            </Button>
          </div>
          <AbstractTable
            showNewBtn={false}
            isHome={true}
            handleTab={this.props.handleTab}
            handleTabAbstract={this.props.handleTabAbstract}
            abstractMode={this.props.abstractMode}
            handleState={this.props.handleState}
          />
        </Grid>
        {/* <Grid item className={classes.gridContainer}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <Typography className={classes.title} gutterBottom>
              Speaker Abstracts Submission
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disableElevation
              onClick={() => this.props.movePage('/speaker/submission')}
            >
              Make a new submission
            </Button>
          </div>
          <SpeakerTable showNewBtn={false} isHome={true} handleTab={this.props.handleTab} handleState={this.props.handleState} />
        </Grid> */}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MyPageHome);
